import { GameScreen } from '../screens/gameScreen';
import { GameService } from '../services/gameService';
import { IocContext } from 'power-di';
import { AnimationService } from '../services/animationService';
import { ScaleService } from '../services/scaleService';

export default class MainScene extends Phaser.Scene {
    private gameService: GameService;
    private animationService: AnimationService;
    constructor() {
        super({ key: 'MainScene' });
    }

    create(): void {
        this.gameService = IocContext.DefaultInstance.get(GameService);
        const scaleService = IocContext.DefaultInstance.get(ScaleService);
        this.animationService = IocContext.DefaultInstance.get(AnimationService);
        this.gameService.setScene(this);
        scaleService.setScene(this);
        this.animationService.setScene(this);
        this.initGameScreen();
    }

    private initGameScreen(): void {
        const gameScreen = new GameScreen(this);
        this.add.existing(gameScreen);
    }
}
